<template>
  <div class="user_info_container_content">
    <div class="title_top_hr">
      <p>
        <i></i>
        <span>我的动态</span>
      </p>
      <el-divider></el-divider>
    </div>
    <div class="personal_dynamic_box"
    v-loading="listLoading"
    element-loading-text="列表加载中"
    element-loading-spinner="el-icon-loading">
      <div v-if="list.length === 0 && !listLoading" class="my_none">
        <img class="my_none_img" src="../../assets/img/user/myDynamicNone.png" alt="我的动态列表为空"><br/>
        <span class="my_none_user_text">暂无动态！</span>
      </div>
      <div class="personal_dynamic_item" v-for="item in list" :key="item.id">
        <div class="personal_dynamic_item_top">
          <p v-if="item.type === 1">我关注了</p>
          <p v-if="item.type === 2">我收藏了</p>
          <p v-if="item.type === 3">我点赞了</p>
          <p v-if="item.type === 4">我点赞了评论</p>
          <p v-if="item.type === 5">我评论了</p>
          <p v-if="item.type === 6">我回复了</p>
          <p v-if="item.type === 7">我发布了</p>
        </div>
        <div class="personal_dynamic_info">
          <p class="personal_dynamic_title" @click="jump(item.data.list_id, item.data.nav_id, item.data.is_doing)">{{item.data.title}}</p>
          <span class="lf">{{item.data.nav_name}}</span>
          <el-divider direction="vertical" class="lf"></el-divider>
          <el-breadcrumb separator="·" class="lf">
            <el-breadcrumb-item v-if="item.date_type === 1 && item.data.is_doing === 0">报名数 {{item.data.favorites}}</el-breadcrumb-item>
            <el-breadcrumb-item v-if="item.date_type === 1 && item.data.is_doing === 1">观看人数 {{item.data.on_count}}</el-breadcrumb-item>
            <el-breadcrumb-item v-if="(item.date_type === 1 &&item.data.is_doing === 2) || item.date_type === 2 || item.date_type === 3 ">阅读量 {{item.data.read}}</el-breadcrumb-item>
            <el-breadcrumb-item v-if="(item.date_type === 1 &&item.data.is_doing === 2) || item.date_type === 2 || item.date_type === 3 ">评论 {{item.data.comment_count}}</el-breadcrumb-item>
            <el-breadcrumb-item v-if="(item.date_type === 1 &&item.data.is_doing === 2) || item.date_type === 2 || item.date_type === 3 ">收藏 {{item.data.favorites}}</el-breadcrumb-item>
            <el-breadcrumb-item v-if="(item.date_type === 1 &&item.data.is_doing === 2) || item.date_type === 2 || item.date_type === 3 ">分享 {{item.data.share}}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </div>
      <el-pagination
        v-if="list.length > 0"
        background
        layout="prev, pager, next"
        :page-size= "listPage.limit"
        :total="listNum"
        @current-change = "pageChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      listLoading: true, // 加载动画
      user: {}, // 用户信息
      list: [],
      listNum: '',
      listPage: {
        user_id: '',
        limit: 10,
        page: 1
      }
    }
  },
  created () {
    this.user = this.$store.state.user.info
    this.listPage.user_id = this.user.id
    this.pageChange()
  },
  methods: {
    pageChange (index) {
      const vueThat = this
      vueThat.listLoading = true
      if (index === undefined) {
        vueThat.listPage.page = 1
      } else {
        vueThat.listPage.page = index
      }
      vueThat.myApi.getMyDynamic(vueThat.listPage).then(function (res) {
        if (res.data.code === 200) {
          vueThat.listLoading = false
          vueThat.list = res.data.data.data
          vueThat.listNum = res.data.data.count
        }
      })
    },
    jump (id, navId, isDoing) {
      this.mycommon.detailJump(this, id, navId, isDoing)
    }
  }
}
</script>

<style>
</style>
